import { useTranslation } from "react-i18next";
import { Grid, Paper, Typography, Modal } from "@material-ui/core";

import { Form, Button, InputGroup } from "react-bootstrap";
import { useEffect, useState } from "react";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { formatTime } from "../../utils/function";

const EnterPassword = (props) => {
  const { t } = useTranslation();
  const [showPwd, setShowPwd] = useState(false);
  const [pwdError, setPwdError] = useState(false);

  const validate = () => {
    let isValid = true;

    setPwdError("");
    if (!props.formValue.password) {
      isValid = false;
      setPwdError(t("Please enter your password"));
    }

    return isValid;
  };

  const handlePasswordToggle = (value) => {
    if (value === "showPwd") {
      setShowPwd(!showPwd);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    props.setformValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      props.handleEnterPassword();
    }
  };

  useEffect(() => {
    props.setformValue((prev) => ({
      ...prev,
      password: "",
    }));
  }, [props.passwordMode]);

  return (
    <Modal
      open={props.passwordMode === "enter"}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      backdrop="static"
    >
      <div className="centered-modal">
        <Form onSubmit={(e) => handleSubmit(e)}>
          <Grid container direction="column" alignItems="center">
            <Grid item xs className="password-modal">
              <Paper className="paper password-body" square>
                <Grid container direction="column" alignItems="center">
                  <Grid item lg>
                    <Typography variant="h4">
                      {t("Enter your password")}
                    </Typography>
                  </Grid>
                  <Grid item sm xs={12} className="password-info">
                    <Typography variant="h6">
                      {t("Enter your password for login your account")}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} className="form-container">
                    <Form.Group>
                      <Form.Label>{t("Password")} *</Form.Label>
                      <InputGroup>
                        <Form.Control
                          name="password"
                          type={showPwd ? "text" : "password"}
                          value={props.formValue.password}
                          onChange={handleChange}
                          id="password"
                          className="text-center"
                          autoComplete="new-password"
                          autoFocus
                          style={{ direction: "ltr" }}
                        />
                        <span
                          onClick={() => handlePasswordToggle("showPwd")}
                          className="eye-icon"
                        >
                          {showPwd ? (
                            <VisibilityOffOutlinedIcon />
                          ) : (
                            <RemoveRedEyeOutlinedIcon />
                          )}
                        </span>
                      </InputGroup>
                      {pwdError && (
                        <span className="errorsmg">{t(`${pwdError}`)}</span>
                      )}
                    </Form.Group>
                  </Grid>
                  <Grid container direction="column" alignItems="center">
                    <Grid
                      item
                      xs
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "15px",
                        margin: "10px",
                      }}
                    >
                      <Button
                        type="submit"
                        className="submit"
                        style={{ maxWidth: "190px", margin: "0px auto" }}
                      >
                        {t("Connect")}
                      </Button>
                      <Button
                        onClick={() => props.handleForgotPassword("forgot")}
                        className="forgot-password"
                      >
                        {t("Forgot Password?")}
                      </Button>
                      <Typography variant="h6">
                        {props.passowrdTimer ? (
                          <span>{formatTime(props.passowrdTimer)}</span>
                        ) : (
                          t("")
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Form>
      </div>
    </Modal>
  );
};
export default EnterPassword;
